<template>
  <div>
    <div class="text-center items-center justify-center relative min-w-0 bg-white w-full h-full shadow-lg rounded-lg">
      <div class="px-4 py-5 items-center">
        <div
          class="mt-5 text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-lg"
        >
          <img
            class="shadow-xl rounded-full h-auto align-middle border-none absolute"
            alt="Team"
            :src="image"
            width="85"
            height="85"
          />
        </div>
        <h6 class="mt-3 text-xl font-semibold">{{name}}</h6>
        <p class="mt-5 mb-4 text-gray-600 font-semibold">
          {{
            owner[0].first_name +
            " " +
            owner[0].last_name
          }}
        </p>
        <p class="mt-2 mb-4 text-gray-600">
          {{description}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* 
  Class: CardMyTeam
  Description: This class representing a cards with single my team.
*/

/* 
  Define props from which we got team id, image, name, owner, description.
*/
export default {
  props: {
    id: null,
    image: null,
    name: null,
    owner: null,
    description: null,
  },
};
</script>
